import { render } from "./PersonalDemo.vue?vue&type=template&id=1a59a284"
import script from "./PersonalDemo.vue?vue&type=script&lang=js"
export * from "./PersonalDemo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukatta_Gov_Eticket\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__